<template>
  <div class="fieldset-text-parts">
    <label :for="id">
      <span class="label-text">{{ label }}</span>
      <span class="required" v-if="required">{{ $tc('formParts.required') }}</span>
    </label>

    <atom-input-text
      :placeholder="placeholder"
      v-model="text"
      :id="id"
      :error="showError"
      :isReadOnly="isReadOnly"
    />

    <form-error-message-parts
      :showError="showError"
      :message="errorMessage !== '' ? errorMessage : $tc('formParts.errorMessage.textNumber')"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import AtomInputText from '@/components/atoms/input/AtomInputText.vue'
import FormErrorMessageParts from '@/components/common/form/FormErrorMessageParts.vue'

/**
 * フィールドセット テキスト(数字) バーツ
 */
export default defineComponent({
  name: 'FieldsetTextParts',
  components: {
    AtomInputText,
    FormErrorMessageParts,
  },
  props: {
    /**
     * データタイトル
     */
    label: {
      type: String,
      default: '',
    },
    /**
     * 入力データ
     */
    id: {
      type: String,
      default: '',
    },
    /**
     * 入力データ
     */
    value: {
      type: String,
      default: '',
    },
    /**
     * 必須フラグ
     */
    required: {
      type: Boolean,
      default: false,
    },
    /**
     * プレースホルダー
     */
    placeholder: {
      type: String,
      default: '',
    },
    /**
     * リードオンリーフラグ
     */
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    /**
     * エラーフラグ
     */
    showError: {
      type: Boolean,
      default: false,
    },
    /**
     * エラーメッセージ
     */
    errorMessage: {
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    /**
     * text
     * @param {string} val
     */
    const text = computed({
      get: () => props.value,
      set: (val: string) => context.emit('input', val),
    })
    return {
      text,
    }
  },
  methods: {
    /**
     * Enter Push
     */
    emitEnter() {
      /**
       * Enterボタン押下を通知する
       * @event login
       * @type {Object}
       */
      this.$emit('enter')
    },
  },
})
</script>

<style lang="scss" scoped>
.fieldset-text-parts {
  @include fieldSet();
}
</style>
